import * as SliderPrimitive from '@radix-ui/react-slider';
import * as React from 'react';

import { cn } from '@/lib/utils';

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>
>(({ className, min = 0, max = 100, ...props }, ref) => {
  const midpoint = Math.floor((Number(min) + Number(max)) / 2);
  return (
    <div className='w-full'>
      <SliderPrimitive.Root
        ref={ref}
        min={min}
        max={max}
        className={cn('relative flex w-full touch-none select-none items-center', className)}
        {...props}
      >
        <SliderPrimitive.Track className='relative h-2 w-full grow overflow-hidden rounded-full bg-secondary cursor-pointer'>
          <SliderPrimitive.Range className='absolute h-full bg-primary' />
        </SliderPrimitive.Track>
        <SliderPrimitive.Thumb className='block h-5 w-5 rounded-full border-2 cursor-pointer border-white bg-foreground ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50' />
      </SliderPrimitive.Root>
      <div className='flex justify-between mt-2 text-sm text-white w-full font-medium'>
        <span>{Number(min) < 10 ? `0${min}` : min}</span>
        <span>{midpoint < 10 ? `0${midpoint}` : midpoint}</span>
        <span>{Number(max) < 10 ? `0${max}` : max}</span>
      </div>
    </div>
  );
});
Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider };
